export const keyboard = [
  { id: 11, buttonName: 'AC' },
  { id: 12, buttonName: '+/-' },
  { id: 13, buttonName: '%' },
  { id: 7, buttonName: '7' },
  { id: 8, buttonName: '8' },
  { id: 9, buttonName: '9' },
  { id: 4, buttonName: '4' },
  { id: 5, buttonName: '5' },
  { id: 6, buttonName: '6' },
  { id: 1, buttonName: '1' },
  { id: 2, buttonName: '2' },
  { id: 3, buttonName: '3' },
  { id: 0, buttonName: '0' },
  { id: 10, buttonName: '.' },

];

export const operators = [
  { id: 14, buttonName: '÷' },
  { id: 15, buttonName: 'x' },
  { id: 16, buttonName: '-' },
  { id: 17, buttonName: '+' },
  { id: 18, buttonName: '=' },
];
